import React, { useMemo, useState } from "react";
import { useForm, useFieldArray } from 'react-hook-form';
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import EzControlledDropDowntWithFloatingLabel from "../EzForm/EzControlledDropDown/WithFloatingLabel";
import { getFormBaseValidationRule } from "../../utils/form/form-utils";
const YES_NO_OPTIONS =
[
    { label: 'DETOUR FREIGHT', value: '621' },
  { label: 'JASS CARRIERS', value: '622' },
]

const AssignCardModal = ({
  isOpen,
  onClose,
  handleAssignRecord,
  manageCardAssignDD,
  title = "Assign Cards",
}) => {

    const {
        control,
        formState: { errors },
        reset,
        handleSubmit
      } = useForm({defaultValues : useMemo(() => ({
        companyid:""
      }), [])});
  const [companyid, setCompanyid] = useState(null);

  const handleFileSelect = (e) => {
    const {id, value} = e.target;
    setCompanyid(value);
  };

  const handleSave = () => {
    handleAssignRecord(companyid);
    handleClose();
    setCompanyid(null)
  };

  const handleClose = () => {
    setCompanyid(null);
    onClose();
    reset()
  };

  return (
    <Dialog
      header={title}
      visible={isOpen}
      onHide={handleClose}
      style={{ width: "25vw" }}
    >
     <EzControlledDropDowntWithFloatingLabel
        name={'companyid'}
        control={control}
        onChange={handleFileSelect}
        rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
        options={manageCardAssignDD}
       
        label="Company"
        labelClassName={'ml-2'}
      />

      <div style={{ marginTop: "20px", textAlign: "right" }}>
        <Button
          label="Cancel"
          className="p-btn-danger p-button-outlined mr-2"
          onClick={handleClose}
        />
        <Button
          label="Save"
          className="p-button-raised"
          onClick={handleSave}
          disabled={!setCompanyid}
        />
      </div>
    </Dialog>
  );
};

export default AssignCardModal;
